class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.hasEnded = false;
    
    // Set hideWhenFinished FIRST, before using it
    this.hideWhenFinished = this.hasAttribute("data-hide-when-finished");
    
// NEW CODE - Safari-safe
this.endDate = new Date().getTime();
if (this.dataset.endDate) {
  // Convert "YYYY/MM/DD HH:MM" to "YYYY-MM-DDTHH:MM" for Safari compatibility
  const safeDate = this.dataset.endDate.replace(/\//g, '-').replace(' ', 'T');
  this.endDate = new Date(safeDate).getTime();
}
    
    this.daysElement = this.querySelector("days");
    this.hoursElement = this.querySelector("hours");
    this.minutesElement = this.querySelector("minutes");
    this.secondsElement = this.querySelector("seconds");
    this.clockElement = this.querySelector("clock");
    this.activeContentElement = this.querySelector("active-content");
    this.endContentElement = this.querySelector("ended-content");
    
    // Check if already ended on load
    const now = new Date().getTime();
    let diff = this.endDate - now;
    if (diff < 0) {
      this.hasEnded = true;
      if (this.hideWhenFinished) {
        this.style.display = "none";
        return;
      }
    }
    
    // Show correct content immediately
    this.showContent();
    
    if (this.endDate) {
      this.setTimer();
    } else {
      console.warn("CountdownTimer Timer needs an end date");
    }
  }
  
  showContent() {
    if (this.activeContentElement) {
      this.activeContentElement.style.display = this.hasEnded ? "none" : "flex";
    }
    if (this.endContentElement) {
      this.endContentElement.style.display = this.hasEnded ? "block" : "none";
    }
    if (this.clockElement) {
      this.clockElement.style.display = this.hasEnded ? "none" : "flex";
    }
  }
  
  setTimer() {
    const timer = () => {
      if (typeof this.endDate != "number") return;
      const now = new Date().getTime();
      let diff = this.endDate - now;
      
      this.hasEnded = diff < 0;
      this.showContent();
      
      // Set parent display for both active and ended states
      this.style.display = "flex";
      this.style.alignItems = "baseline";
      
      // Don't continue updating digits if ended
      if (this.hasEnded) {
        if (this.hideWhenFinished) {
          this.style.display = "none";
        }
        return;
      }
      
      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      if (this.daysElement) this.updateDigits(this.daysElement, days);
      if (this.hoursElement) this.updateDigits(this.hoursElement, hours);
      if (this.minutesElement) this.updateDigits(this.minutesElement, minutes);
      if (this.secondsElement) this.updateDigits(this.secondsElement, seconds);
      
      this.setDisplay(this.daysElement, days);
      this.setDisplay(this.hoursElement, hours);
      this.setDisplay(this.minutesElement, minutes);
      this.setDisplay(this.secondsElement, seconds, true);
    };
    
    timer();
    setInterval(timer, 1000);
  }
  
  setDisplay(element, timer, alwaysShow = false) {
    if (!element) return;
    if (Math.round(timer) > 0) {
      element.style.display = "flex";
    } else if (!alwaysShow) {
      element.style.display = "none";
    }
  }
  
updateDigits(digitElement, value) {
  if (!digitElement) return;
  const zeroPad = (num, places) => String(num).padStart(places, "0");
  let values = zeroPad(value, 2).split("");
  let html = '<span class="digits">' + values.map(v => `<span class="digit">${v}</span>`).join("") + '</span>';
  
  let existingDigits = digitElement.querySelector(".digits");
  if (existingDigits) {
    existingDigits.innerHTML = values.map(v => `<span class="digit">${v}</span>`).join("");
  } else {
    digitElement.innerHTML = html;
  }
}
}

customElements.define("countdown-timer", CountdownTimer);